import { InjectionToken } from '@angular/core';

import type { Logger } from './logger';
import { consoleLogger } from './logger';

/**
 * Logger for code that renders both in the browser and on the SSR server. The
 * server binds the request-scoped pino logger to it, so a line logged during a
 * render lands in Kibana next to the request that caused it.
 */
export const LOGGER = new InjectionToken<Logger>('logger', {
	providedIn: 'root',
	factory: () => consoleLogger,
});
